import { useAtom } from 'jotai';

import * as state from '@/state';
import { Snackbar } from './Snackbar';

export const GlobalSnackbar = () => {
  const [snackbarMessage, setSnackbarMessage] = useAtom(state.snackbarMessage);

  const closeSnack = (_?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarMessage({ shouldShow: false, content: undefined });
  };

  const { shouldShow, content } = snackbarMessage;

  return (
    <Snackbar sxProps={{ top: '56px !important' }} open={shouldShow} onClose={closeSnack}>
      {content}
    </Snackbar>
  );
};
